import { Button, Flex } from "antd";
import SearchInitiatorFilter from "components/AISeearchMain/SearchInitiatorFilters";
import { useAppSelector } from "hooks/reduxHooks";
import { SvgIcons } from "Icon/SvgIcons";
import React from "react";
import { useSearchParams } from "react-router-dom";
import SearchCandidateButton from "./SearchCandidateButton";

const AIFilterModalHeader = ({ setIsSearchLoading, showDrawer, runFrom, isModal, handleCloseModal, isSearchButton = true }: any) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const isNamedSearch = useAppSelector((state) => state.search.isNamedSearch);

  const searchId: any = searchParams.get("searchId");

  const handleNavigation = (processSearchId: string | number, graph_search_id: string | number, projectId: string | number) => {
    const newSearchParams = new URLSearchParams(searchParams);

    // Update only the step parameter, preserving all others
    newSearchParams.set("searchId", String(processSearchId));
    newSearchParams.set("search_id", String(graph_search_id));
    newSearchParams.set("projectId", String(projectId));
    newSearchParams.set("step", "4");

    // Set the updated search parameters
    setSearchParams(newSearchParams);
    handleCloseModal();
    // onNext();

  };

  return (
    <Flex justify="space-between" gap={16} className="p-6 pb-5 bg-bg-primary rounded-t-xl">
      <Flex gap={16}>
        {!isNamedSearch && (
          <span onClick={showDrawer} className="cursor-pointer">
            {SvgIcons.featuredIcon}
          </span>
        )}
        <Flex vertical className="items-center">
          <span className="text-lg font-semibold capitalize text-center">
            {isNamedSearch
              ? "Search By Name"
              : "Define your ideal candidate profile"}{" "}
          </span>
        </Flex>
      </Flex>
      <Flex className="pr-10 flex justify-end items-center gap-[10px]">
        {isSearchButton ? <SearchCandidateButton
          setIsSearchLoading={false}
          runFrom="Chatbot"
          handleNavigation={handleNavigation}
        /> :
          <Button type="primary" onClick={handleCloseModal}>
            Save
          </Button>}
      </Flex>
    </Flex>
  );
};

export default AIFilterModalHeader;
